

































































































































































































































































































import {
  defineComponent,
  computed,
  ref,
  onMounted
} from '@nuxtjs/composition-api'
import CImg from '~/components/shared/configurable/image/CImg.vue'
import { useNamespacedStore } from '~/compositions/store'
import CCountTo from '~/components/shared/configurable/CCountTo.vue'
import {
  QUICK_SEARCH_NS,
  QuickSearchState
} from '~/store/modules/shared/quickSearch/state'
import { Facet as FacetType, Config } from '~/models/quick-search/types'
import Facet from '~/components/shared/quick-search/facets/Facet.vue'
import { capitalizeSentences } from '~/utils/string'
import { formatNumber } from '~/utils/number'
import { SET_CONFIG } from '~/store/modules/shared/quickSearch/mutation-types'
import { CategoryId } from '~/models/category/types'
import { addYears, format } from '~/utils/date'
import CDatepicker from '~/components/shared/configurable/date/CDatepicker.vue'
import { useQuickSearchParams } from '~/compositions/quick-search/useQuickSearchParams'
import CContactForm from '~/components/shared/configurable/CContactForm.vue'
import HeadService from '~/services/HeadService'

export default defineComponent({
  components: { CImg, Facet, CDatepicker, CContactForm },
  async asyncData({ store, app: { i18n } }: any) {
    const config: Config = {
      baseUrl: '/api/rentals/quick-search/',
      rootCategoryId: CategoryId.RENTALS,
      title: i18n.t('vehicle rentals')
    }
    store.commit(`${QUICK_SEARCH_NS}/${SET_CONFIG}`, config)
    await Promise.all([
      store.dispatch(`${QUICK_SEARCH_NS}/loadData`),
      store.dispatch(`${QUICK_SEARCH_NS}/loadCategoriesData`)
    ])
  },
  setup() {
    const { changeParams } = useQuickSearchParams()
    const { state } = useNamespacedStore<QuickSearchState>(QUICK_SEARCH_NS)
    const facets: FacetType = computed(() => state.facets)
    const today = ref(new Date())
    const period = ref<Date | null>(null)
    const maxDate = addYears(new Date(), 1).toISOString()

    onMounted(() => clearFacets())

    const textForProfectionals = computed(() => {
      return {
        en: {
          first: 'Are you',
          second: 'a rental services',
          third: 'professional?'
        },
        el: {
          first: 'Είσαι επαγγελματίας',
          second: 'που δραστηριοπoιείται στον χώρο',
          third: 'των ενοικιάσεων?'
        }
      }
    })

    const targets = computed(() => state.targets)
    const targetUrl = computed(() => targets.value.search?.seoUrl || null)
    const total = computed(() => state.stats.total)
    const showButtonDisabled = computed(() => !targetUrl)

    const category = computed(() =>
      facets.value.find(f => f.name === 'category')
    )
    const pickupLocation = computed(() =>
      facets.value.find(f => f.name === 'pickup_location')
    )
    const rentalPeriod = computed(() =>
      facets.value.find(f => f.name === 'rental_period')
    )

    const oneYearLater = computed(() => addYears(today.value, 1))
    const datepickerFromMinDate = computed(() => today.value.toISOString())
    const datepickerFromMaxDate = computed(() =>
      oneYearLater.value.toISOString()
    )

    function handleDateChange({ start, end }: { start: Date; end: Date }) {
      changeParams([
        { name: `${rentalPeriod.value.urlArg}-from`, value: formatDate(start) },
        { name: `${rentalPeriod.value.urlArg}-to`, value: formatDate(end) }
      ])
    }

    function formatDate(date: Date) {
      return format(date, 'd/M/yyyy')
    }

    function clearFacets() {
      changeParams([
        { name: category.value.urlArg, value: null },
        { name: `${rentalPeriod.value.urlArg}-from`, value: null },
        { name: `${rentalPeriod.value.urlArg}-to`, value: null },
        { name: pickupLocation.value.urlArg, value: null }
      ])
    }

    return {
      facets,
      capitalizeSentences,
      targetUrl,
      CCountTo,
      formatNumber,
      total,
      showButtonDisabled,
      category,
      pickupLocation,
      rentalPeriod,
      period,
      handleDateChange,
      maxDate,
      today,
      textForProfectionals,
      datepickerFromMinDate,
      datepickerFromMaxDate
    }
  },
  head() {
    const headService = this.$dep(HeadService)
    return headService.createHead({
      title: 'Eνοικίαση αυτοκινήτου σε όλη την Ελλάδα (Μάθε πως)',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            'Ενοικιάσεις αυτοκινήτων, μοτοσυκλετών, επαγγελματικών οχημάτων και ό,τι άλλο μπορείς να φανταστείς. Ενοικίαση απλά & εύκολα σε όλη την Ελλάδα, με τη βοήθεια του Car.gr.'
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content:
            'Ενοικιάσεις αυτοκινήτων, μοτοσυκλετών, επαγγελματικών οχημάτων και ό,τι άλλο μπορείς να φανταστείς. Ενοικίαση απλά & εύκολα σε όλη την Ελλάδα, με τη βοήθεια του Car.gr'
        },
        headService.createOgImageMetaItem('/nuxt-static/img/og/rentals.png')
      ]
    })
  }
})
